import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow",
  "use": "icon-down-arrow-usage",
  "viewBox": "0 0 8.253 4.475",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.253 4.475\" id=\"icon-down-arrow\"><defs><style>#icon-down-arrow .a{fill:#d9d9d9;}</style></defs><path class=\"a\" d=\"M324.828,170.353a.35.35,0,0,1-.247-.1l-3.779-3.779a.347.347,0,0,1,0-.493l3.778-3.778a.345.345,0,0,1,.247-.1.348.348,0,0,1,.247.595l-3.532,3.531,3.532,3.532a.348.348,0,0,1-.245.595Z\" transform=\"translate(-162.1 325.175) rotate(-90)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol